import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dept-exam-record-from',
  templateUrl: './dept-exam-record-from.component.html',
  styleUrls: ['./dept-exam-record-from.component.css']
})
export class DeptExamRecordFromComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component.ts